import React from 'react';
import styled from 'styled-components';
import { Bio } from '../../data/constants';

const FooterContainer = styled.div`
  width: 100%;
  padding: 80px 0 40px 0;
  display: flex;
  justify-content: center;
  background: radial-gradient(circle at top, rgba(168,85,247,0.08), transparent 60%),
              linear-gradient(180deg, #000000 0%, #050505 100%);
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: -80px;
    left: 0;
    width: 100%;
    height: 200px;
    background: radial-gradient(circle at 50% 0%, rgba(168,85,247,0.15), transparent 70%);
    filter: blur(40px);
    opacity: 0.5;
  }

  &::after {
    content: "RAKESH KUMAR";
    position: absolute;
    font-size: 140px;
    font-weight: 900;
    color: rgba(255, 255, 255, 0.035);
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    letter-spacing: 10px;
    pointer-events: none;
    text-shadow: 0 0 25px rgba(168,85,247,0.12);
  }
`;

const FooterWrapper = styled.footer`
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  gap: 60px;
  padding: 0 40px;
  color: #FFFFFF;
  z-index: 2;
`;

const MainGrid = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1fr;
  gap: 40px;

  @media (max-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

const BrandSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 26px;
  font-weight: 900;
  color: #FFFFFF;

  img {
    width: 62px;
    height: 62px;
    object-fit: contain;
    filter: drop-shadow(0 0 12px rgba(168,85,247,0.6));
  }
`;

const BioText = styled.p`
  font-size: 14px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.6;
  max-width: 250px;
`;

const LinkColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const ColumnTitle = styled.h4`
  font-size: 12px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.4);
  text-transform: uppercase;
`;

const NavLink = styled.a`
  font-size: 14px;
  color: #FFFFFF;
  text-decoration: none;
  font-weight: 500;

  &:hover {
    color: #A855F7;
    transform: translateX(5px);
  }
`;

const BottomBar = styled.div`
  padding-top: 40px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.4);

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 20px;
  }
`;

const LegalLinks = styled.div`
  display: flex;
  gap: 24px;
`;

function Footer() {
  return (
    <FooterContainer>
      <FooterWrapper>
        <MainGrid>

          <BrandSection>
            <Logo>
              <img src="https://raw.githubusercontent.com/Rakeshere/web-docx/main/image.png" alt="RK Logo" />
              <span>RAKESH KUMAR</span>
            </Logo>
            <BioText>
              I'm Rakesh: A product-driven strategist and engineer focused on crafting high-impact digital experiences.
            </BioText>
          </BrandSection>

          <LinkColumn>
            <ColumnTitle>General</ColumnTitle>
            <NavLink href="#about">Home</NavLink>
            <NavLink href="#about">About</NavLink>
            <NavLink href="#projects">Projects</NavLink>
            <NavLink href="#docs">Docs</NavLink>
          </LinkColumn>

          <LinkColumn>
            <ColumnTitle>Specifics</ColumnTitle>
            <NavLink href="#skills">Stack</NavLink>
            <NavLink href="#experience">Workflow</NavLink>
            <NavLink href="#contact">Contact</NavLink>
          </LinkColumn>

          <LinkColumn>
            <ColumnTitle>More</ColumnTitle>
            <NavLink href={Bio.linkedin || "https://linkedin.com"} target="_blank" rel="noreferrer">LinkedIn</NavLink>
            <NavLink href={Bio.twitter || "https://twitter.com"} target="_blank" rel="noreferrer">Twitter</NavLink>
            <NavLink href={Bio.github || "https://github.com"} target="_blank" rel="noreferrer">Github</NavLink>
          </LinkColumn>

        </MainGrid>

        <BottomBar>
          <div>© 2026 Rakesh Kumar. All rights reserved.</div>
          <LegalLinks>
            <NavLink href="/privacy-policy">Privacy Policy</NavLink>
            <NavLink href="/terms">Terms of Use</NavLink>
          </LegalLinks>
        </BottomBar>

      </FooterWrapper>
    </FooterContainer>
  );
}

export default Footer;